var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import {useState, useCallback} from "react";
import {
  AudioInputTest,
  AudioOutputTest,
  testAudioInputDevice,
  testAudioOutputDevice
} from "@twilio/rtc-diagnostics";
import {getAudioLevelPercentage, getStandardDeviation} from "../utils";
import {RECORD_DURATION} from "../constants";
let audioInputTest;
let audioOutputTest;
const getErrorMessage = (error) => {
  let message = "An unknown error has occurred";
  if (error) {
    message = error.domError ? error.domError.toString() : error.message;
  }
  return message;
};
export default function useAudioTest() {
  const [isRecording, setIsRecording] = useState(false);
  const [isAudioInputTestRunning, setIsAudioInputTestRunning] = useState(false);
  const [isAudioOutputTestRunning, setIsAudioOutputTestRunning] = useState(false);
  const [inputLevel, setInputLevel] = useState(0);
  const [outputLevel, setOutputLevel] = useState(0);
  const [playbackURI, setPlaybackURI] = useState("");
  const [error, setError] = useState("");
  const playAudio = useCallback((options) => {
    options = __spreadValues({doLoop: false}, options);
    audioOutputTest = testAudioOutputDevice(options);
    setIsAudioOutputTestRunning(true);
    audioOutputTest.on(AudioOutputTest.Events.Volume, (value) => {
      setOutputLevel(getAudioLevelPercentage(value));
    });
    audioOutputTest.on(AudioOutputTest.Events.End, (report) => {
      setIsAudioOutputTestRunning(false);
      setOutputLevel(0);
      const stdDev = getStandardDeviation(report.values);
      if (stdDev === 0) {
        setError("No audio detected");
      }
    });
    audioOutputTest.on(AudioOutputTest.Events.Error, (diagnosticError) => {
      setError(getErrorMessage(diagnosticError));
    });
  }, []);
  const readAudioInput = useCallback((options) => {
    if (audioInputTest) {
      audioInputTest.stop();
    }
    const duration = options.enableRecording ? RECORD_DURATION : void 0;
    options = __spreadValues(__spreadValues({}, duration ? {duration} : {}), options);
    audioInputTest = testAudioInputDevice(options);
    setIsAudioInputTestRunning(true);
    if (options.enableRecording) {
      setIsRecording(true);
    }
    audioInputTest.on(AudioInputTest.Events.Volume, (value) => {
      setInputLevel(getAudioLevelPercentage(value));
    });
    audioInputTest.on(AudioInputTest.Events.End, (report) => {
      if (playbackURI && report.recordingUrl) {
        URL.revokeObjectURL(playbackURI);
      }
      if (report.recordingUrl) {
        setPlaybackURI(report.recordingUrl);
      }
      setIsRecording(false);
      setIsAudioInputTestRunning(false);
    });
    audioInputTest.on(AudioInputTest.Events.Error, (diagnosticError) => {
      setError(getErrorMessage(diagnosticError));
    });
  }, [playbackURI]);
  const stopAudioTest = useCallback(() => {
    if (audioInputTest) {
      audioInputTest.stop();
      audioInputTest = void 0;
      setInputLevel(0);
    }
    if (audioOutputTest) {
      audioOutputTest.stop();
      audioOutputTest = void 0;
      setOutputLevel(0);
    }
  }, []);
  return {
    error,
    setError,
    isRecording,
    isAudioInputTestRunning,
    isAudioOutputTestRunning,
    playAudio,
    playbackURI,
    readAudioInput,
    stopAudioTest,
    inputLevel,
    outputLevel
  };
}
